import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as navigationActions from "../../../../actions/navigationActions";
import * as rccActions from "../../../../actions/rccActions";
import * as componentTypes from "../../../../constants/componentTypes";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as formatHelper from "../../../../helpers/formatHelper";
import * as windowService from "../../../../services/windowService";

import imgClose from "../../../../resources/img/svgicons/close-black.svg";
import noImg from "../../../../resources/img/no-image.png";
import imgCancel from "../../../../resources/img/svgicons/cancel.svg";
import imgPrint from "../../../../resources/img/svgicons/print.svg";
import imgSave from "../../../../resources/img/svgicons/save.svg";

class PrintPreviewModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchClosePrintModalAction();
    };

    handleSaveAsButtonClick = () => {
        let printImage = window.imageStore.getPrintImageByName(this.props.templateName);

        if (printImage !== null) {
            windowService.openSaveDialog(printImage.img, formatHelper.formatFileName("IMG", printImage.type));
        }
    };

    getCanisterImage = () => {
        let canisterImage = window.imageStore.getMachineCanister();

        if (this.state.canister === null || canisterImage === null) {
            return "";
        }

        return (
            <div className="canister-image">
                <img alt="" src={"data:" + canisterImage.type + ";base64," + canisterImage.img} />
            </div>
        );
    };

    getPrinterImage = (printImage) => {
        if (printImage !== null) {
            let printerName = validationHelper.getPrinter(this.props.printerList, this.props.selectedPrinter);

            return (
                <div className="right-part col-xs-12">
                    <img
                        alt={printerName ? printerName : this.props.printer.name}
                        src={"data:" + printImage.type + ";base64," + printImage.img}
                    />
                </div>
            );
        }

        return (
            <div className="right-part col-xs-12">
                <img alt="preview" src={noImg} />
            </div>
        );
    };

    componentDidMount = () => {
        if (this.props.formula && this.props.printData && this.props.templateList.length > 0) {
            this.props.dispatchGetPrintPreviewImageAction(this.props.tabId);
        }
    };

    handlePrintClick = () => {
        this.props.dispatchStartPrintReportSilentAction(
            this.props.tabId,
            this.props.templateName,
            validationHelper.getPrinter(this.props.printerList, this.props.selectedPrinter),
            this.props.numberOfLabels
        );
    };

    getPrintButton = (printImage) => {
        if (
            this.props.templateName !== null &&
            this.props.product !== null &&
            this.props.fandeck !== null &&
            this.props.formula !== null &&
            this.props.base !== null &&
            this.props.package !== null &&
            printImage !== null
        ) {
            return (
                <button className="btn btn-info" onClick={this.handlePrintClick}>
                    <ReactSVG className="pull-left btn-icon" src={imgPrint} alt="print" />
                    <Translate value="general.print" />
                </button>
            );
        }

        return (
            <button className="btn btn-info disabled">
                <ReactSVG className="pull-left btn-icon" src={imgPrint} alt="print" />
                <Translate value="general.print" />
            </button>
        );
    };

    getSaveAsButton = (printImage) => {
        if (windowService.isBrowser()) {
            return "";
        }

        if (printImage === null) {
            return (
                <button className="btn btn-info disabled">
                    <ReactSVG className="pull-left btn-icon" src={imgSave} alt="save" />
                    <Translate value="general.saveAs" />
                </button>
            );
        }

        return (
            <button className="btn btn-info" onClick={this.handleSaveAsButtonClick}>
                <ReactSVG className="pull-left btn-icon" src={imgSave} alt="save" />
                <Translate value="general.saveAs" />
            </button>
        );
    };

    render() {
        let printImage = window.imageStore.getPrintImageByName(this.props.templateName);

        return (
            <div id="modal" className="default-modal bigger-modal printer-modal">
                <header className="color-primary uppercase">
                    <Translate value="colorantsTable.preview" />
                    <div className="modal-close" onClick={this.handleCloseModalClick}>
                        <ReactSVG src={imgClose} className="close-img" alt="close" />
                    </div>
                </header>
                <div className="modal-content color-primary">{this.getPrinterImage(printImage)}</div>
                <div className="col-xs-12 text-right modal-footer">
                    {this.getPrintButton(printImage)}
                    {this.getSaveAsButton(printImage)}
                    <button className="btn btn-info action-button" onClick={this.handleCloseModalClick}>
                        <ReactSVG className="pull-left action-icon" src={imgCancel} alt="cancel" />
                        <Translate value="general.cancel" />
                    </button>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (store.formula[ownProps.tabId] === undefined) {
        return {
            printer: store.rcc.printer,
            selectedPrinter: store.settings.printer,
            templateName: validationHelper.getValidItem(store.rcc.templateList, store.settings.printerTemplate),
            printerList: store.rcc.printerList,
            templateList: store.rcc.templateList,
            printData: null,
            product: null,
            fandeck: null,
            formula: null,
            base: null,
            package: null,
            numberOfLabels: 1,
            imageStore: store.navigation.imageStore
        };
    }

    return {
        printer: store.rcc.printer,
        selectedPrinter: store.settings.printer,
        printerList: store.rcc.printerList,
        templateName: validationHelper.getValidItem(store.rcc.templateList, store.settings.printerTemplate),
        templateList: store.rcc.templateList,
        printData: store.formula[ownProps.tabId].printData,
        product: store.formula[ownProps.tabId].product,
        fandeck: store.formula[ownProps.tabId].fandeck,
        formula: store.formula[ownProps.tabId].formula,
        base: store.formula[ownProps.tabId].base,
        package: store.formula[ownProps.tabId].package,
        numberOfLabels: store.formula[ownProps.tabId].numberOfLabels,
        imageStore: store.navigation.imageStore
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchClosePrintModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.PRINT_PREVIEW_MODAL));
        },
        dispatchGetPrintPreviewImageAction: (tabId) => {
            dispatch(rccActions.getPrintPreviewImage(tabId));
        },
        dispatchStartPrintReportSilentAction: (tabId, template, printer, pages) => {
            dispatch(rccActions.startPrintReportSilent(tabId, template, printer, pages));
        }
    };
};

export default PrintPreviewModal = connect(mapStoreToProps, mapDispatchToProps)(PrintPreviewModal);
